//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const SmsMessages: FeatureFlag = {"Id":"SmsMessages","Label":"Enable sending SMS Messages (manual changes required before enabling)","Impact":"Allow sending SMS message. Adjust the SMS quota before enabling this.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
